/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import * as Ui from './styles';

export function RadioButton({
  // Atributo de Tag HTML
  id,
  // Texto de exibição
  label,
  // Atributo de agrupamento da Tag HTML
  name,
  // Define se o radio está ou não selecionado
  checked,
  // Define que o componente será renderizado sobre um fundo escuro
  dark = false,
  // Valor do radio
  value,
  // Define se o ícone de marcação aparecerá ou não
  withIcon = true,
  // Propaga o evento de seleção do radio
  onChange,
  // for styled-components
  className,
}) {
  return (
    <Ui.Container className={className}>
      <label className="radio-button">
        <input
          id={id}
          title={label}
          name={name}
          checked={checked}
          value={value}
          type="radio"
          className={'radio-button-input'}
          onChange={onChange}
        />
        {withIcon && (
          <span className={dark ? 'radio-button-control dark' : 'radio-button-control'} />
        )}
        <span className="radio-button-label" htmlFor={id}>{label}</span>
      </label>
    </Ui.Container>
  );
}
